// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata';
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/libphonenumber-js/es6/getCountryCallingCode.js
// module id = ../../../../libphonenumber-js/es6/getCountryCallingCode.js
// module chunks = 3